import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { MemberPermissionSale } from '../../../models/sales/membe-permission-sale.model';
import { SaleHorse, SaleHorseStatus } from '../../../models/sales/sale-horse.model';
import * as Actions from './sales.action';
import * as Selectors from './sales.selector';

@Injectable()
export class SalesFacade {
  sales$ = this.store.select(Selectors.selectSales);
  salesActiveForSubmission$ = this.store.select(
    Selectors.selectSalesActiveForSubmission
  );
  salesLoaded$ = this.store.select(Selectors.selectSalesLoaded);
  salesListError$ = this.store.select(Selectors.salesListError);

  saleHorses$ = this.store.select(Selectors.selectSaleHorses);
  saleHorsesLoaded$ = this.store.select(Selectors.selectSaleHorsesLoaded);
  saleProfileError$ = this.store.select(Selectors.saleProfileError);
  saleMemberAccess$ = this.store.select(Selectors.selectSaleMemberAccess);
  selectSaleHorse$ = this.store.select(Selectors.selectSaleHorse);
  selectSyncSaleHorse$ = this.store.select(Selectors.selectSyncSaleHorse);
  selectStautsSaleHorse$ = this.store.select(Selectors.selectStautsSaleHorse);
  selectUpdateSaleMemberAccess$ = this.store.select(Selectors.selectUpdateSaleMemberAccess);
  selectSaleMemberPermission$ = this.store.select(Selectors.selectSaleMemberPermission);
  saleStatuses$ = this.store.select(Selectors.selectSaleStatuses);
  saleStatusesLoaded$ = this.store.select(Selectors.selectSaleStatusesLoaded);

  constructor(private store: Store) {}

  loadSales(): void {
    this.store.dispatch(Actions.GetSales());
  }

  loadSale(saleId: number): void {
    this.store.dispatch(Actions.GetSaleById({ saleId }));
  }

  loadSaleHorses(saleId: number): void {
    this.store.dispatch(Actions.GetSaleHorses({ saleId }));
  }
  loadSaleHorse(saleId: number, horseId: number) {
    this.store.dispatch(Actions.GetSaleHorse({ saleId, horseId }));
  }

  acceptTermsAndConditions(saleId: number): void {
    this.store.dispatch(Actions.AcceptSaleTermsAndConditions({ saleId }));
  }

  resetErrorState(): void {
    this.store.dispatch(Actions.ResetErrorState());
  }

  loadSaleMemberAccess(saleId: number, horseId?: number): void {
    this.store.dispatch(Actions.GetMemberAccessForSale({ saleId, horseId }));
  }    
  
  loadSaleStatuses(saleId:number) {
    this.store.dispatch(Actions.GetSaleStatuses({ saleId }));
  }
  syncSaleHorse(saleId:number): void {
    this.store.dispatch(Actions.SyncTwSaleHorseData({ saleId }));
  }
  clearSyncedSaleHorse(): void {
    this.store.dispatch(Actions.clearSynced());
  }
  updateSaleHorseStatus(saleHorse: SaleHorseStatus) {
    this.store.dispatch(Actions.updateSaleHorseStatus({ saleHorse }));
  }
  updateSaleMemberAccess(model: MemberPermissionSale[]) {
    this.store.dispatch(Actions.UpdateSaleMemberAccess({ model }));
  }
  clearSaleMemberAccess() {
    this.store.dispatch(Actions.ClearSaleMemberAccess());
  }
  loadSaleMemberPermission(memberId: number): void {
    this.store.dispatch(Actions.GetSaleMemberAccess({ memberId }));
  }
}
